// src/services/sensorService.js
import axios from 'axios';

// 외부 접근을 위한 백엔드 API 호출
// 환경변수로 설정하거나 현재 도메인의 8000 포트 사용
// const API_BASE_URL =
//   (import.meta?.env?.VITE_API_BASE) ||
//   process.env.REACT_APP_API_BASE_URL ||
//   process.env.REACT_APP_API_URL ||
//   (typeof window !== 'undefined' ? `${window.location.protocol}//${window.location.hostname}:8000` : 'http://localhost:8000');
const API_BASE_URL =
    (import.meta?.env?.VITE_API_BASE) ||
    (typeof window !== 'undefined' ? `${window.location.origin}/api` : '/api');

// 공용 axios 인스턴스
export const api = axios.create({
  baseURL: API_BASE_URL,   // 예: '/api' 또는 'https://iot.example.com/api'
  timeout: 60_000,         // 느린 쿼리 대비
  // withCredentials: true, // 쿠키/세션 필요할 때만 켜세요
});

export const fetchSensorData = async (startDate, endDate, filterType = 'all', machine = '', endpoint = '/data') => {
  const params = new URLSearchParams();
  if (startDate) params.append('start_date', startDate);
  if (endDate) params.append('end_date', endDate);
  
  // 5초 집계 데이터는 filter_type 사용 안함
  if (endpoint !== '/data-5s' && filterType) params.append('filter_type', filterType);
  if (machine) params.append('machine', machine);
  
  // const response = await axios.get(`${API_BASE_URL}${endpoint}?${params}`);
  const { data } = await api.get(endpoint, { params });
  //return response.data;
  return data;
};

export const fetchLatestSensorData = async () => {
  try {
    const { data } = await api.get('/latest');
    return data;
  } catch (e) {
    const { data } = await api.get('/latest-influx');
    return data;
  }
};

export const fetchMachines = async () => {
  const { data } = await api.get('/machines');
  return data;
};

export const fetchSensors = async (machine = '') => {
  const params = machine ? { machine } : {};
  const { data } = await api.get('/sensors', { params });
  return data;
};

export const fetchSensorsByMachine = async (machine) => {
  const { data } = await api.get('/sensors-by-machine', { params: { machine } });
  return data;
};

export const updateMachineStatus = async (machineId, isActive) => {
  const { data } = await api.put(`/machines/${machineId}/status`, {
    is_active: isActive
  });
  return data;
};